import type { ReelDraft } from '@/lib/reel';
type Props = {
  draft: ReelDraft;
  selected: string | null;
  duration: number;
  onChange: (draft: ReelDraft) => void;
  disabled: boolean;
};
export function ReelTextTiming({ draft, selected, duration, onChange, disabled }: Props) {
  if (!draft.layers.some((l) => l.id === selected && l.kind === 'text')) return null;
  const timing = draft.layerTimings?.find((t) => t.layerId === selected);
  const update = (startMs: number, endMs: number) =>
    onChange({
      ...draft,
      layerTimings: [
        ...(draft.layerTimings ?? []).filter((t) => t.layerId !== selected),
        {
          layerId: selected!,
          startMs: Math.round(Math.max(0, Math.min(endMs - 1, startMs))),
          endMs: Math.round(Math.min(duration, Math.max(startMs + 1, endMs))),
        },
      ],
    });
  return (
    <fieldset className="picture-tools" disabled={disabled}>
      <strong>Text timing</strong>
      <label>
        <input
          type="checkbox"
          checked={!!timing}
          onChange={(e) =>
            e.target.checked
              ? update(0, duration)
              : onChange({
                  ...draft,
                  layerTimings: (draft.layerTimings ?? []).filter((t) => t.layerId !== selected),
                })
          }
        />{' '}
        Show during part of the Reel
      </label>
      {timing && (
        <div className="picture-row">
          <label>
            Start{' '}
            <input
              aria-label="Text starts at"
              type="number"
              min={0}
              max={(timing.endMs - 1) / 1000}
              step={0.1}
              value={timing.startMs / 1000}
              onChange={(e) => update(Number(e.target.value) * 1000, timing.endMs)}
            />
          </label>
          <label>
            End{' '}
            <input
              aria-label="Text ends at"
              type="number"
              min={(timing.startMs + 1) / 1000}
              max={duration / 1000}
              step={0.1}
              value={timing.endMs / 1000}
              onChange={(e) => update(timing.startMs, Number(e.target.value) * 1000)}
            />
          </label>
        </div>
      )}
      <span className="composer-hint">
        Seconds from the Reel’s beginning, after trimming and ordering clips.
      </span>
    </fieldset>
  );
}
